import { render, staticRenderFns } from "./JobsDresdenGO.vue?vue&type=template&id=257d4840&scoped=true"
import script from "./JobsDresdenGO.vue?vue&type=script&lang=js"
export * from "./JobsDresdenGO.vue?vue&type=script&lang=js"
import style0 from "./JobsDresdenGO.vue?vue&type=style&index=0&id=257d4840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257d4840",
  null
  
)

export default component.exports